import { get, remove } from '../Services/http'
import { catchError } from './Error.action'
import { FACETED_SEARCH_LOADING } from './FacetedSearch.action'

const rootRoute = '/api/vehicleFinder'

export const VEHICLEFINDER_RECEIVE = 'VEHICLEFINDER_RECEIVE'
export const VEHICLEFINDER_ERROR = 'VEHICLEFINDER_ERROR'

export const getVehicleDataByRegNo = (regNo, callback) => async (dispatch) => {
    dispatch({
        type: FACETED_SEARCH_LOADING,
        payload: {
            loading: true
        }
    })

    return get(rootRoute + '/SearchVehicle/' + regNo)
        .then((response) => response.json())
        .then((data) => {
            dispatch(receive(data))
            runCallback(callback, data)
        })
        .catch((ex) => {
            runCallback(callback)
            dispatch(catchError(ex, (error) => loadError(error)))
            dispatch({
                type: FACETED_SEARCH_LOADING,
                payload: {
                    loading: false
                }
            })
        })
}

export const getVehicleDataByVariantId = (vehicleVariantId, callback) => async (
    dispatch
) => {
    dispatch({
        type: FACETED_SEARCH_LOADING,
        payload: {
            loading: true
        }
    })

    return get(rootRoute + '/GetVehicle/' + vehicleVariantId)
        .then((response) => response.json())
        .then((data) => {
            dispatch(receive(data))
            runCallback(callback, data)
        })
        .catch((ex) => {
            runCallback(callback)
            dispatch(catchError(ex, (error) => loadError(error)))
            dispatch({
                type: FACETED_SEARCH_LOADING,
                payload: {
                    loading: false
                }
            })
        })
}

export const removeVehicle = () => async (dispatch) => {
    return remove(rootRoute + '/RemoveVehicle')
        .then(() => dispatch(receive(null)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const receive = (vehicleData) => ({
    type: VEHICLEFINDER_RECEIVE,
    payload: {
        vehicleData,
        errors: [],
    },
})

export const loadError = (error) => ({
    type: VEHICLEFINDER_ERROR,
    payload: {
        error,
    },
})

export const clearState = () => (dispatch) => {
    return dispatch(receive(null))
}

function runCallback(callback, data = null) {
    if (callback) {
        callback(data)
    }
}
